<template>
  <router-link class="action-link block" :class="{ active: isActiveLink }" :to="link">
    <v-icon :color="color || 'black'" small>{{ icon }}</v-icon>
  </router-link>
</template>

<script>
export default {
  noExport: true,
  props: ['value', 'icon', 'color', 'link',],
  computed: {
    isActiveLink() {
      return this.$route.name === this.link.name;
    },
  },
}
</script>

<style lang="scss" scoped>
.action-link {
  border-radius: 7px;
  .active {
    background-color: rgba(133, 199, 211, 0.23);
  }
}
</style>